import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import features from "shared/services/features";

export default function useOutreachTiers() {
  const hasBasicContactSearchOnly = computed(
    () =>
      features.has("has_outreach_search_only") &&
      !features.has("has_outreach_activities_lists_search") &&
      !features.has("has_outreach_media_releases")
  );

  const hasOutreachActivitiesListsSearch = computed(
    () =>
      features.has("has_outreach_search_only") &&
      features.has("has_outreach_activities_lists_search")
  );

  const hasOutreachMediaReleases = computed(
    () =>
      features.has("has_outreach_search_only") &&
      features.has("has_outreach_activities_lists_search") &&
      features.has("has_outreach_media_releases")
  );

  const outreachUpgradeText = computed(() => {
    if (hasBasicContactSearchOnly.value) {
      return getLocaleText("outreach.tooltips.search_only_upgrade");
    }

    return getLocaleText("outreach.tooltips.media_release_upgrade");
  });

  return {
    hasBasicContactSearchOnly,
    hasOutreachActivitiesListsSearch,
    hasOutreachMediaReleases,
    outreachUpgradeText,
  };
}
